import { 
    Grid, 
    Typography, 
    TextField,
} from '@mui/material';

export default function FrameSectionPatientOwn({ 
    frameData, 
    inProgress,
    onFrameDataChange
}) {

    return (
        <Grid container spacing={1} p={1} boxShadow={2} sx={{ mb: 2, border: '1px solid #ccc', borderRadius: 1 }}>
            <Grid item xs={6}>
                <TextField
                    fullWidth
                    label="Model #"
                    variant="outlined"
                    size="small"
                    value={frameData.customerSuppliedFrame.modelNumber}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('customerSuppliedFrame.modelNumber', e.target.value)}
                    inputProps={{ style: { textTransform: 'uppercase' },}}
                />
            </Grid>
            {/* <Grid item xs={6}>
                <TextField
                    fullWidth
                    label="Supplier"
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={frameData.customerSuppliedFrame.supplier || ''}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('customerSuppliedFrame.supplier', e.target.value)}
                />
            </Grid> */}
            <Grid item xs={6}>
                <TextField
                    fullWidth
                    label="Brand"
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={frameData.customerSuppliedFrame.brand || ''}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('customerSuppliedFrame.brand', e.target.value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    fullWidth
                    label="Frame Color"
                    variant="outlined"
                    size="small"
                    value={frameData.customerSuppliedFrame.frameColor || ''}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('customerSuppliedFrame.frameColor', e.target.value)}
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    fullWidth
                    label="Color Code"
                    variant="outlined"
                    size="small"
                    value={frameData.customerSuppliedFrame.frameColorCode || ''}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('customerSuppliedFrame.frameColorCode', e.target.value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label="Material"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={frameData.customerSuppliedFrame.material || ''}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('customerSuppliedFrame.material', e.target.value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label="Rim Type"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={frameData.customerSuppliedFrame.rimType || ''}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('customerSuppliedFrame.rimType', e.target.value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label="Shape"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={frameData.customerSuppliedFrame.shape || ''}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('customerSuppliedFrame.shape', e.target.value)}
                />
            </Grid>
            <Grid item xs={3}>
                <TextField label="A" variant="outlined" size="small"  fullWidth value={frameData.customerSuppliedFrame.aMeasurement || ''} onChange={(e) => onFrameDataChange && onFrameDataChange('customerSuppliedFrame.aMeasurement', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="B" variant="outlined" size="small"  fullWidth value={frameData.customerSuppliedFrame.bMeasurement || ''} onChange={(e) => onFrameDataChange && onFrameDataChange('customerSuppliedFrame.bMeasurement', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="ED" variant="outlined" size="small"  fullWidth value={frameData.customerSuppliedFrame.edMeasurement || ''} onChange={(e) => onFrameDataChange && onFrameDataChange('customerSuppliedFrame.edMeasurement', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="DBL" variant="outlined" size="small"  fullWidth value={frameData.customerSuppliedFrame.dblMeasurement || ''} onChange={(e) => onFrameDataChange && onFrameDataChange('customerSuppliedFrame.dblMeasurement', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="Eye" variant="outlined" size="small"  fullWidth value={frameData.customerSuppliedFrame.eyeSize || ''} onChange={(e) => onFrameDataChange && onFrameDataChange('customerSuppliedFrame.eyeSize', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="Temp" variant="outlined" size="small"  fullWidth value={frameData.customerSuppliedFrame.templeLength || ''} onChange={(e) => onFrameDataChange && onFrameDataChange('customerSuppliedFrame.templeLength', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="CIRC" variant="outlined" size="small"  fullWidth value={frameData.customerSuppliedFrame.circumference || ''} onChange={(e) => onFrameDataChange && onFrameDataChange('customerSuppliedFrame.circumference', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField label="BRDG" variant="outlined" size="small"  fullWidth value={frameData.customerSuppliedFrame.bridgeSize || ''} onChange={(e) => onFrameDataChange && onFrameDataChange('customerSuppliedFrame.bridgeSize', e.target.value)} />
            </Grid>
            <Grid item xs={3}>
                <TextField
                    variant="filled"
                    size="small"
                    label="Price"
                    type='text'
                    
                    value={`${frameData.listPrice || '0.00'}`}
                    onChange={(e) => onFrameDataChange && onFrameDataChange('listPrice', e.target.value)}
                    //onChange={(e) => setFramePrice(e.target.value)}
                    InputProps={{ startAdornment: <Typography sx={{ mr: 1 }}>$</Typography> }}
                />
            </Grid>
        </Grid>
    );
}